import React, { Component } from 'react';
import {
  Route,
  withRouter,
  Switch
} from 'react-router-dom';

import Login from '../user/login/Login';
import Signup from '../user/signup/Singup';
import NotFound from '../common/NotFound';
import { getCurrentUser } from '../util/APIUtils';
import { ACCESS_TOKEN,SESSION_USER,SSO_PARAMS } from '../constants';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoute from '../common/PrivateRoute';
import Dashboard from '../dashboard/Dashboard';
import Header from '../common/Header';
import NavMenu from '../common/NavMenu';
import Footer from '../common/Footer';
import LoginSessionRoute from '../common/LoginSessionRoute';
import Skill from '../user/skill/Skill';
import SkillForm from '../user/skill/SkillForm';

import People from '../user/people/People';
import PeopleForm from '../user/people/PeopleForm';
import Team from '../user/team/Team';
import TeamForm from '../user/team/TeamForm';

import Equipment from '../user/equipment/Equipment';
import EquipmentForm from '../user/equipment/EquipmentForm';

import Schedule from '../user/schedule/Schedule';
import Profile from '../user/setting/Profile';
import Setting from '../user/setting/Setting';
import JobSchedule from '../user/jobschedule/JobSchedule';
import EquipmentView from '../user/equipmentview/EquipmentView';
import TeamView from '../user/teamview/TeamView';
import LocationView from '../user/locationview/LocationView';

import Location from '../user/location/Location';
import LocationForm from '../user/location/LocationForm';



import LoginAuto from '../user/sso/LoginAuto';


class App extends Component {

      constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            isAuthenticated: false
        }
          this.handleLogout = this.handleLogout.bind(this);
          this.loadCurrentUser = this.loadCurrentUser.bind(this);
          this.handleLogin = this.handleLogin.bind(this);
          this.handleSuccessLogin = this.handleSuccessLogin.bind(this);
        
      }



loadCurrentUser() {
    getCurrentUser()
    .then(response => {
        // alert("call req");
      //  console.log(response);
        // alert("call res");
      this.setState({
        currentUser: response,
        isAuthenticated: true
      });
    //  alert("value set");
     

    }).catch(error => {
        alert("app js loadCurrentUser");
    });
  }


  componentDidMount() {
  // this.loadCurrentUser();
  //console.log(window.location.pathname); 
  }

  
 handleLogout(redirectTo="/", notificationType="success", description="You're successfully logged out.") {
    localStorage.removeItem(ACCESS_TOKEN);
     localStorage.removeItem(SESSION_USER);
    localStorage.removeItem(SSO_PARAMS);
    this.setState({
      currentUser: null,
      isAuthenticated: false
    });

    this.props.history.push(redirectTo);
  }
  
      handleSuccessLogin() {
         toast.success('Successfully registered!',{autoClose: false,hideProgressBar: false,closeOnClick: true,pauseOnHover: true});
         this.props.history.push("/login");
      }
       handleLogin() {
             //this.loadCurrentUser();
              getCurrentUser()
              .then(response => {
                 // console.log(response);
                this.setState({
                  currentUser: response,
                  isAuthenticated: true
                });

                localStorage.setItem(SESSION_USER, JSON.stringify(response));
                this.props.history.push("/schedule");
              }).catch(error => {
                  alert("app js loadCurrentUser");
              });
       }

  render() {  
    const divStyle = {
             //backgroundImage:'url(./static/assets/images/background/login-register.jpg)',
         };

    return (


      <div id="main-wrapper" >
     
       
        {//<Header/>
        //localStorage.getItem(ACCESS_TOKEN) ? (<NavMenu/>):null
        }            
       

        <div className="page-wrapper" style={divStyle}>
            <div className="container-fluid">
            
            <Switch>        
                  <Route exact  path="/" render={(props) => <Login onLogin={this.handleLogin} {...props} />}></Route>

                  <Route path="/sso/:ssoid"  component={LoginAuto}  ></Route>

                  <LoginSessionRoute exact  path="/login" render={(props) => <Login onLogin={this.handleLogin} {...props} />}></LoginSessionRoute>

                  <Route path="/signup" 
                    render={(props) => <Signup onSuccessLogin={this.handleSuccessLogin} {...props} />}>
                  </Route>

                
                  <PrivateRoute authenticated={this.state.isAuthenticated} path="/dashboard" component={Dashboard} handleLogout={this.handleLogout}></PrivateRoute>
                 
                  <PrivateRoute authenticated={this.state.isAuthenticated} path="/skills" component={Skill} handleLogout={this.handleLogout}></PrivateRoute>
                  <PrivateRoute authenticated={this.state.isAuthenticated} path="/skill/:skillId" component={SkillForm} handleLogout={this.handleLogout}></PrivateRoute>
                 
                  <PrivateRoute path="/peoples" component={People} handleLogout={this.handleLogout}></PrivateRoute>
                  <PrivateRoute  path="/people/:peopleId" component={PeopleForm} handleLogout={this.handleLogout}></PrivateRoute>
                 
                  <PrivateRoute path="/teams" component={Team} handleLogout={this.handleLogout}></PrivateRoute>
                  <PrivateRoute path="/team/:teamId" component={TeamForm} handleLogout={this.handleLogout}></PrivateRoute>
                
                  <PrivateRoute path="/equipments" component={Equipment} handleLogout={this.handleLogout}></PrivateRoute>
                  <PrivateRoute path="/equipment/:equipmentId" component={EquipmentForm} handleLogout={this.handleLogout}></PrivateRoute>
                
                  
                  <PrivateRoute path="/jobschedule" component={JobSchedule} handleLogout={this.handleLogout}></PrivateRoute>
                  <PrivateRoute path="/equipmentview" component={EquipmentView} handleLogout={this.handleLogout}></PrivateRoute>
                  <PrivateRoute path="/teamview" component={TeamView} handleLogout={this.handleLogout}></PrivateRoute>
                  <PrivateRoute path="/locationview" component={LocationView} handleLogout={this.handleLogout}></PrivateRoute>
            
              
                  <PrivateRoute path="/schedule" component={Schedule} handleLogout={this.handleLogout}></PrivateRoute>
                
                  <PrivateRoute path="/profile" component={Profile} handleLogout={this.handleLogout}></PrivateRoute>
                
                  <PrivateRoute path="/settings" component={Setting} handleLogout={this.handleLogout}></PrivateRoute>
                
                     <PrivateRoute path="/locations" component={Location} handleLogout={this.handleLogout}></PrivateRoute>
                  <PrivateRoute path="/location/:locationId" component={LocationForm} handleLogout={this.handleLogout}></PrivateRoute>
            

                  <Route component={NotFound}></Route>
          
              </Switch> 
          
            </div>
           <Footer/>
        </div>
       
    </div>


                
    );
  }
}


export default withRouter(App);
